<template>
  <v-container class="my-10">
    <h1 class="mx-10 mb-2 display-3 text-center">Welcome to UT<strong>OT</strong></h1>
    <p class="text-center">
      Until Then <strong>Online Tools</strong><br>
      A crude web app with manual cloud syncing<br>
      Not recommended for mobile viewing<br><br>
      UT<strong>OT</strong> automatically saves locally every 10 seconds.<br>
      <strong>Save</strong> commits your changes to the interwebs.<br>
      <strong>Fetch</strong> pulls the last commit from the interwebs.
    </p>
  </v-container>
</template>

<script>
export default {
  name: 'Home'
}
</script>